import axios from 'axios';
import { API_URL } from './AppConstent';

const api = axios.create({
    baseURL: API_URL,
    withCredentials: true,
});

let isRefreshing = false;
let subscribers = [];

const subscribeTokenRefresh = (cb) => {
    subscribers.push(cb);
};

const onRefreshed = () => {
    subscribers.forEach(cb => cb());
    subscribers = [];
};

api.interceptors.request.use(
    async config => {
        if (isRefreshing) {
            return new Promise(resolve => {
                subscribeTokenRefresh(() => resolve(config));
            });
        }
        return config;
    },
    error => Promise.reject(error)
);

api.interceptors.response.use(
    res => res,
    async (error) => {
        const originalRequest = error.config;
        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;
            if (!isRefreshing) {
                isRefreshing = true;
                try {
                    await api.post(`${API_URL}auth/refreshPOSUser`);
                    isRefreshing = false;
                    onRefreshed();
                    return api(originalRequest);
                } catch (refreshError) {
                    isRefreshing = false;
                    subscribers = [];
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/';
                    return Promise.reject(refreshError);
                }
            }
            return new Promise(resolve => {
                subscribeTokenRefresh(() => resolve(api(originalRequest)));
            });
        }
        return Promise.reject(error);
    }
);

export default api;